import React from 'react'

import { Card, Flex, Header, Icon, IconButton, Text, Tooltip } from '@driftt/dds'
import { faCircleInfo } from '@driftt/dds.icons/light/faCircleInfo'
import { faThumbsDown } from '@driftt/dds.icons/light/faThumbsDown'
import { faThumbsUp } from '@driftt/dds.icons/light/faThumbsUp'
import { faSparkles } from '@driftt/dds.icons/solid/faSparkles'

import { useAIEngagementSummary } from 'hooks/useAIEngagementSummary'

interface AIEngagementSummaryProps {
  accountId: string
  css?: any
}

const AIEngagementSummary = ({ accountId }: AIEngagementSummaryProps) => {  
  const {
    showFeedback, 
    trackFeedback, 
    content,
    headerCopy,
    tooltipCopy,
    feedbackCopy
  } = useAIEngagementSummary(accountId, 'Main')

  return (
    <Card css={{ marginBottom: "16px" }}>
      <Card.Header>
        <Flex direction="row" justifyContent="space-between" alignItems="center">
          <Flex direction="row" alignItems="center">
            <Icon icon={faSparkles} color="purple7" />
            <Header variant="h3">{headerCopy}</Header>
            <Tooltip content={tooltipCopy}side="top">
              <Icon icon={faCircleInfo} />
            </Tooltip>
          </Flex>
          {showFeedback && (
            <Flex direction="row" alignItems="center" gap="half">
              <Text variant="subtitle2">{feedbackCopy}</Text>
              <IconButton
                icon={faThumbsUp}
                title="It was useful"
                size="small"
                onClick={() => trackFeedback(true)}
              />
              <IconButton
                icon={faThumbsDown}
                title="It was not useful"
                size="small"
                onClick={() => trackFeedback(false)}
              />
            </Flex>
          )}
        </Flex>
      </Card.Header>
      <Card.Content>
        {content}
      </Card.Content>
    </Card>
  )
}

export default AIEngagementSummary
